const TESTERS = [
  'Lina Jensen',
  'Lisa Bryer',
  'Milosz Gruszka',
  'Malin Brander',
  'Björn Östberg',
  'Anna Maria Erling',
  'Joakim Lind',
  'Martin Wellershaus',
  'Henrik Lindström',
  'Johan Olsson',
];

export function SpecialThanks() {
  return (
    <section className="special-thanks">
      <h2>Stort tack till våra betatestare!</h2>
      <h3>Ett särskilt tack till</h3>
      <ul className="thanks-list">
        {TESTERS.map(name => (
          <li key={name}>{name}</li>
        ))}
      </ul>
    </section>
  );
}
